module.exports = __webpack_public_path__ + "img/manorBig.eca3bc46.png";